/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import caseExecutionJobDetailsPageStyle from "../CaseExecutionJobDetailsPage/caseExecutionJobDetailsPageStyle";

export default caseExecutionJobDetailsPageStyle;
